<template>
  <textarea type="text" :value="props.value" @input="handleInput" ref="textAreaRef" />
</template>

<script setup>
import { onMounted, ref, watch } from 'vue'
import setAdaptiveTextArea from '@utils/adaptiveTextArea'

const textAreaRef = ref(null)

const props = defineProps({
  value: {
    type: [String, Number],
    required: false,
    default: '',
  },
})

const emits = defineEmits(['input'])

const updateHeight = () => {
  setTimeout(() => setAdaptiveTextArea(textAreaRef.value))
}

const handleInput = e => {
  emits('input', e.target.value)
}

watch(
  () => props.value,
  () => {
    updateHeight()
  }
)

onMounted(() => {
  setTimeout(() => updateHeight(), 100)
})
</script>
